import { render } from "./SendEmailConfirmation.vue?vue&type=template&id=65fa6a3c&scoped=true"
import script from "./SendEmailConfirmation.vue?vue&type=script&lang=ts"
export * from "./SendEmailConfirmation.vue?vue&type=script&lang=ts"

import "./SendEmailConfirmation.vue?vue&type=style&index=0&id=65fa6a3c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-65fa6a3c"

export default script